import { IkasProductAttributeTableTemplate } from "./table-template";
import { IkasProductAttributeOption } from "./option";
import { IkasProductAttributeTranslation } from "./translation";

export type IkasProductAttribute = {
  id: string;
  name: string;
  description: string | null;
  type: IkasProductAttributeType;
  options: IkasProductAttributeOption[] | null;
  tableTemplate: IkasProductAttributeTableTemplate | null;
  translations?: IkasProductAttributeTranslation[] | null;
};

export enum IkasProductAttributeType {
  CHOICE = "CHOICE",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  TEXT = "TEXT",
  BOOLEAN = "BOOLEAN",
  NUMERIC = "NUMERIC",
  DATETIME = "DATETIME",
  HTML = "HTML",
  TABLE = "TABLE",
  IMAGE = "IMAGE",
  PRODUCT = "PRODUCT",
}
